module.exports = __webpack_public_path__ + "static/img/2.325cf16.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/12/zh/2.png
// module id = lEYb
// module chunks = 0